import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import { formatValue } from "../../../utilities";
import { orderByValues } from "../../../data/data";
import styleConstants from "../../../styleConstants";
import MirroredBarChart from "../../chart/MirroredBarChart";

const ShareOfUsersWithinPrivateSectorByMethodChart = props => {
  const data = props.data;

  return (
    <MirroredBarChart
      ref={props.innerRef}
      height={200}
      headerOffset={95}
      categories={methods}
      series={[
        {
          name: "Private (Subsidized)",
          color:
            styleConstants.categoryColors.sectorColors["Private Subsidized"],
          data: orderByValues(
            data.filter(datum => datum.sector === "Private Sub"),
            methods,
            "method"
          ).map(datum => -datum.value)
        },
        {
          name: "Private (Non-Subsidized)",
          color:
            styleConstants.categoryColors.sectorColors[
              "Private Non-Subsidized"
            ],
          data: orderByValues(
            data.filter(datum => datum.sector === "Private Non-Sub"),
            methods,
            "method"
          ).map(datum => datum.value)
        }
      ]}
      legendPosition="none"
      absolute={props.absolute}
      tooltipFormatter={function() {
        return `${this.series.name} ${this.key} Users: <strong>${formatValue(
          Math.abs(this.y)
        )}</strong><br />Share of Private ${
          this.key
        } Users: <strong>${formatValue(this.point.proportion, true)}</strong>`;
      }}
    />
  );
};

ShareOfUsersWithinPrivateSectorByMethodChart.propTypes = {
  data: PropTypes.array.isRequired,
  absolute: PropTypes.bool
};

export default memo(
  React.forwardRef((props, ref) => (
    <ShareOfUsersWithinPrivateSectorByMethodChart innerRef={ref} {...props} />
  ))
);
